/* eslint-disable prettier/prettier */
/* eslint-disable no-undef */
import DokanTableEditDropdown from "../../components/table/DokanTableEditDropdown";
import DokanTableItemPrice from "../../components/table/DokanTableItemPrice";
import DokanTableItemRating from "../../components/table/DokanTableItemRating";
import DokanTableItemShortDetails from "../../components/table/DokanTableItemShortDetails/DokanTableItemShortDetails";
import DokanTableItemStatus from "../../components/table/DokanTableItemStatus/DokanTableItemStatus";
import defaultImg from '../../assets/images/defaultImage.svg';

// Column data as render props pattern
// eslint-disable-next-line import/prefer-default-export
export const productsColumnData = [
  {
    rowClassName: "dokan-row",
    className: "dokan-th",
    title: "Product Name",
    dataIndex: "id",
    key: "id",
    render: (text, record) => (
      <DokanTableItemShortDetails
        productImage={record.images[0].is_featured === true ? record.images[0].src : defaultImg}
        productName={record.name}
        isFeatured={record.featured}
        id={record.id}
        productCategories={record.categories}
        productType={record.type}
      />
    ),
  },
  {
    title: "SKU",
    dataIndex: "sku",
    key: "id",
    render: (sku) => <p className="text-sm text-secondary font-light">{sku}</p>,
  },
  {
    title: "Stock",
    dataIndex: "in_stock",
    key: "id",
    render: (_, record) => (
      <p className="text-sm text-secondary font-light">
        {record.in_stock ? "Available" : "Not Available"}
      </p>
    ),
  },
  {
    title: "Price",
    dataIndex: "type",
    key: "id",
    render: (type, record) => (
      <DokanTableItemPrice
        styleClasses={
          type === "grouped" || type === "variable"
            ? ""
            : "flex flex-col-reverse"
        }
      >
        {record.price_html}
      </DokanTableItemPrice>
    ),
  },
  {
    title: "Earning",
    dataIndex: "earning",
    key: "id",
    render: () => <p className=" text-sm text-primary font-semibold ">&nbsp;</p>,
  },
  {
    title: "Status",
    dataIndex: "status",
    key: "id",
    render: (status, record) => (
      <DokanTableItemStatus
        status={record.status}
        date={record.date_created}
        views={23}
        dateLabel="Published"
      />
    ),
  },
  {
    title: "Ratings",
    dataIndex: "rating_count",
    key: "id",
    render: (_, record) => (
      <DokanTableItemRating ratingCount={record.rating_count} />
    ),
  },
  {
    title: "",
    dataIndex: "",
    key: "id",
    render: (menu, record) => <DokanTableEditDropdown record={record} />,
  },
];
